import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { T4D, T2D, T2R } from '../components/Text';

import { h2 } from '../styles/text';
import { media, colors } from '../styles/constants';

const QuoteContainer = styled.blockquote`
  display: flex;
  flex-direction: column;
`;

const Bubble = styled.div`
  margin: 4rem 0;
  position: relative;
  border-radius: 2.6rem;
  background-color: ${colors.cyan};
  padding: 3rem;
  margin-bottom: 4rem;

  @media (min-width: ${media.tabletPortrait}) {
    margin-bottom: 5rem;
    padding: 4rem 4.7rem;
    border-radius: 5.2rem;
  }

  && ${T4D} {
    color: ${colors.white};
    padding: 0;
    margin: 0;
  }

  p, h1, h2, h3, h4, h5, h6, span, a {
    ${h2}
    color: ${colors.white};
    padding: 0 !important;
    margin: 0 !important;
  }

  /* [Style] Enclosing bubble style */
  :after {
    content: '';
    position: absolute;
    left: auto;
    bottom: -3rem;
    right: 5rem;
    width: 0;
    height: 0;
    z-index: -1;
    border-style: solid;
    border-width: 3rem 0 3rem 3rem;
    border-color: transparent transparent transparent ${colors.cyan};

    @media (min-width: ${media.tabletPortrait}) {
      border-width: 5.2rem 0 5.2rem 5.2rem;
      bottom: -5rem;
      right: 10rem;
    }
  }
`;

const Quote = ({ text, attributes, children }) => {
  if (children) {
    return (
      <QuoteContainer>
        <Bubble>{children}</Bubble>
      </QuoteContainer>
    );
  }

  if (text && Array.isArray(attributes)) {
    const [author, ...otherAttrs] = attributes;
    return (
      <QuoteContainer>
        <Bubble>
          <T4D>{text}</T4D>
        </Bubble>
        {attributes && (
          <>
            <T2D>{author}</T2D>
            {otherAttrs.map((attr, i) => (
              <T2R key={i}>{attr}</T2R>
            ))}
          </>
        )}
      </QuoteContainer>
    );
  }

  return null;
};

Quote.propTypes = {
  text: PropTypes.string,
  attributes: PropTypes.array,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default Quote;
